import React from 'react';
import { CheckIcon, ShieldCheckIcon, XIcon } from 'lucide-react';
import { closingWith, closingWithout, product } from '../data/landing';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
export function ClosingSection() {
  return <section className="bg-navy py-12 text-white md:py-24" data-id="element-28" data-mp="xtqxeahgd27y">
      <div className="mx-auto max-w-[1000px] px-5 md:px-8" data-id="element-29" data-mp="xsfqw2wmhgd5">
        <SectionHeading tone="dark" eyebrow="The choice is simple" title="Next week can start" highlight="with a plan." data-id="element-30" data-mp="1cq85msuci0qa" />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-31" data-mp="17r5bi3fwlex3">
          <div className="rounded-2xl border border-white/10 bg-navy-deep p-7 md:p-8" data-id="element-32" data-mp="1ljuyaa39anv9">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-white/80" data-id="element-33" data-mp="1hhzxd6p8mci0">Keep planning from scratch</h3>
            <ul className="mt-6 space-y-4" data-id="element-34" data-mp="1vikhq7aswgdm">
              {closingWithout.map(item => <li key={item} className="flex items-start gap-3 text-white/70" data-id="element-35" data-mp="1qj7l4uu4nuxu">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-white/40" aria-hidden="true" data-id="element-36" data-mp="22cvr8bibxziq" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-amber bg-white p-7 shadow-[0_20px_50px_rgba(0,0,0,0.25)] md:p-8" data-id="element-37" data-mp="2cajq9dmyxt6p">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-navy" data-id="element-38" data-mp="2gcdlh6eea4zh">
              With <span className="text-teal" data-id="element-39" data-mp="2lbzwd96r3954">{product.name}</span>
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-40" data-mp="2qa1ik2zh3okt">
              {closingWith.map(item => <li key={item} className="flex items-start gap-3 font-medium text-navy" data-id="element-41" data-mp="2v11aettqjggg">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-cream" data-id="element-42" data-mp="2v3dtxbf55yvm">
                    <CheckIcon className="h-3 w-3 text-amber-dark" strokeWidth={3} aria-hidden="true" data-id="element-43" data-mp="3427x5kmz9ni5" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-44" data-mp="18zcmcb80hpv8">
          <p className="text-white/80 md:text-lg" data-id="element-45" data-mp="14wy3hr4ceq3y">
            12 complete meetings + 5 bonus resources ·{' '}
            <b className="text-amber" data-id="element-46" data-mp="1io2wiad7gk5b">
              ${product.price} {product.currency}
            </b>
            , one-time payment
          </p>
          <CtaButton href="#offer-details" className="mt-7 w-full sm:w-auto" data-id="element-47" data-mp="1dw32eyjtglgn">
            {product.ctaLabel} now
          </CtaButton>
          <p className="mt-5 flex items-center justify-center gap-1.5 text-[13px] text-white/60" data-id="element-48" data-mp="1nnft3mtvp5l3">
            <ShieldCheckIcon className="h-4 w-4 text-teal-light" aria-hidden="true" data-id="element-49" data-mp="21n8f54ugmxmq" />
            10-day money-back guarantee · No questions asked
          </p>
        </div>
      </div>
    </section>;
}